"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReversibleMap = void 0;
class ReversibleMap {
    constructor() {
        this.valueToKey = new Map();
        this.keyToValue = new Map();
        this.setUnique = (key, value) => {
            if (this.hasKey(key) || this.hasValue(value)) {
                throw new Error('Key or value already in the map.');
            }
            this.keyToValue.set(key, value);
            this.valueToKey.set(value, key);
        };
        this.getKey = (value) => {
            const existingKey = this.valueToKey.get(value);
            if (!existingKey) {
                throw new Error('Value not found in the map.');
            }
            return existingKey;
        };
        this.deleteKey = (key) => {
            const value = this.getValue(key);
            this.keyToValue.delete(key);
            this.valueToKey.delete(value);
            return value;
        };
        this.deleteValue = (value) => {
            const key = this.getKey(value);
            this.keyToValue.delete(key);
            this.valueToKey.delete(value);
            return key;
        };
        this.hasKey = (key) => {
            return this.keyToValue.has(key);
        };
        this.hasValue = (value) => {
            return this.valueToKey.has(value);
        };
    }
    getValue(key) {
        const item = this.keyToValue.get(key);
        if (!item) {
            throw new Error('Key not found in the map.');
        }
        return item;
    }
}
exports.ReversibleMap = ReversibleMap;
